"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.collaboratorCursorSelector = exports.collaboratorSelector = exports.collaboratorSocketSelector = void 0;
const lodash_1 = require("lodash");
const reselect_1 = require("reselect");
const resource_1 = require("./resource");
const createDeepEqualSelector = (0, reselect_1.createSelectorCreator)(reselect_1.defaultMemoize, lodash_1.isEqual);
const collaboratorSocketSelector = (state, datasheetId) => {
    const client = (0, resource_1.getDatasheetClient)(state, datasheetId);
    return client && client.collaborators;
};
exports.collaboratorSocketSelector = collaboratorSocketSelector;
/**
 * display avatars on the status bar,
 * one user can use multiple client to connect to the same datasheet room.
 * But collaborator avatars are only displayed once.
 */
exports.collaboratorSelector = createDeepEqualSelector(exports.collaboratorSocketSelector, collaborators => {
    if (collaborators) {
        return (0, lodash_1.uniqBy)(collaborators, 'userId');
    }
    return [];
});
exports.collaboratorCursorSelector = (0, reselect_1.createSelector)([exports.collaboratorSocketSelector, resource_1.getActiveDatasheetId], (collaborators, _activeDatasheetId) => {
    const collaboratorCursorMap = {};
    collaborators
        .filter(collaborator => collaborator.activeCell)
        .map(collaborator => {
        return {
            fieldId: collaborator.activeCell.fieldId,
            recordId: collaborator.activeCell.recordId,
            avatar: collaborator.avatar,
            socketId: collaborator.socketId,
            userId: collaborator.userId,
            userName: collaborator.userName,
            memberName: collaborator.memberName,
            touchTime: collaborator.activeCell.time, // the time of active cell
        };
    }).forEach(r => {
        const key = `${r.fieldId}_${r.recordId}`;
        if (collaboratorCursorMap.hasOwnProperty(key)) {
            collaboratorCursorMap[key].push(r);
        }
        else {
            collaboratorCursorMap[key] = [r];
        }
    });
    return collaboratorCursorMap;
});
//# sourceMappingURL=collaborators.js.map